// Components==============
import { AnimatePresence } from 'framer-motion';
import { useRootModal } from 'hooks/useRootModal';
import React from 'react';
import './RootModal.module.scss';
// =========================

export default function RootModal() {
  const { rootModal } = useRootModal();

  return <AnimatePresence>{rootModal}</AnimatePresence>;
}
